export default __webpack_public_path__ + "static/media/6.ea9607cc.png";